import { render, staticRenderFns } from "./IndividualPTOPolicy.vue?vue&type=template&id=1cd74495&scoped=true&"
import script from "./IndividualPTOPolicy.vue?vue&type=script&lang=ts&"
export * from "./IndividualPTOPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./IndividualPTOPolicy.vue?vue&type=style&index=0&id=1cd74495&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd74495",
  null
  
)

export default component.exports